import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material';
import { PaginatedModel } from 'src/app/dominio/paginated-model';
import { PaginatorServiceV2 } from '../../services/paginator-service-v2';
import { CarregandoService } from 'src/app/services/carregando.service';
import { QueryFilterService } from '../../services/query-filter-service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { GridfyFilter } from '../../models/gridfy-filter';
import { TermoAceiteService } from '../../services/termo-aceite.service';
import { TermoAceiteUsuarioModel } from 'src/app/dominio/termo-aceite-usuario-model';

@Component({
  selector: 'app-termos-aceitos',
  templateUrl: './termos-aceitos.component.html',
  styleUrls: ['./termos-aceitos.component.scss']
})
export class TermosAceitosComponent implements OnInit {

  @Input() tipoUsuario: number;
  @Input() idUsuario: number;

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;
  paginador: PaginatedModel;

  aceites: TermoAceiteUsuarioModel[] = [];

  campoOrdenacao = 'dataHora';
  ordenarDesc = true;

  constructor(private paginatorServiceV2: PaginatorServiceV2,
    private carregandoService: CarregandoService,
    private queryFilterService: QueryFilterService,
    private notificacaoService: NotificacaoService,
    private termoAceiteService: TermoAceiteService
  ) { }

  ngOnInit() {
    this.paginador = this.paginatorServiceV2.createInstance();

    this.buscarAceites();
  }

  mudaDePagina(pageEvent: PageEvent) {
    this.paginador.page = pageEvent.pageIndex + 1;
    this.paginador.pageSize = this.paginatorServiceV2.setPageSize(pageEvent.pageSize);

    this.buscarAceites();
  }

  buscarAceites() {
    this.carregandoService.mostra('buscarAceites');

    const queryFilter = this.queryFilterService.getQueryBuilder()
      .setPage(this.paginador.page)
      .setPageSize(this.paginador.pageSize).addOrderBy(this.campoOrdenacao, this.ordenarDesc).build();

    this.termoAceiteService.buscarTermosAceitos(this.tipoUsuario, this.idUsuario, queryFilter).subscribe(data => {
      this.aceites = data.results;
      this.paginador = this.paginatorServiceV2.createInstance(data.pagination);
      this.carregandoService.esconde('buscarAceites');
    }, (erro) => {
      this.carregandoService.esconde('buscarAceites');
      this.notificacaoService.erro(erro);
    });
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

}
